import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
//import { fetchPosts } from '../actions/postsActions';
//import { Post } from '../components/Post';
import {
    createStyles,
    Progress,
    Text,
    ScrollArea,
    Card,
    ActionIcon
} from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import { useSelector } from 'react-redux';
import { FooterSimple } from '../components/FooterSimple';
import { MobileSimpleHeader } from '../components/MobileSimpleHeader';

import{
    IconBell,
} from '@tabler/icons';
import { AlertFilter } from '../components/AlertFilter';
import  AlertItem  from '../components/AlertItem';


import pagani from '../assets/pagani.jpg';


const useStyles = createStyles((theme) => ({
    alertFilter: {
        position: 'absolute',
        left: '50px',
        //width: '30%',
        //margin: '0 auto'
    },
    noListingsContain: {
        maxWidth: '800px',
        width: '80%',
        margin: '0 auto'
    },
    centerItem: {
        margin: '0 auto'
    }
}));


//this needs params
const AlertsPage = () => {
    const { classes, theme } = useStyles();
    const { height, width } = useViewportSize();
    console.log(`n height\n ${height * 0.8}`);
    
    //will be a map to items in redux based on new or read
    const alertItems = null;
    let no_alerts = <Card withBorder radius="md" className={classes.noListingsContain}><Text ta="center"><ActionIcon className={classes.centerItem}><IconBell/></ActionIcon>    No New Alerts</Text></Card>
    return (
        <>
            {/*
            <MobileSimpleHeader 
                avatar={pagani}
                drawSubSectMenu={false}
            />*/}

            {/*have a switch case for assignment of the sub menu*/}
            <br/>
            <AlertFilter className={classes.alertFilter}/>
            <br/>
            <br/>
            <ScrollArea 
                h={height * 0.65}
            >
                {no_alerts}
                {/*
                <AlertItem
                    par="subscribers_5"
                    alertTime="05/25/2023 @ 02:00PM"
                    msg="You have a new subscriber, Click here for more details"
                />
                <br/>
                <AlertItem
                    par="subscribers_5"
                    alertTime="05/25/2023 @ 02:00PM"
                    msg="You have a new subscriber, Click here for more details"
                />
                <AlertItem
                    par="subscribers_5"
                    alertTime="05/25/2023 @ 02:00PM"
                    msg="You have a new subscriber, Click here for more details"
                />
                <AlertItem
                    par="subscribers_5"
                    alertTime="05/25/2023 @ 02:00PM"
                    msg="You have a new subscriber, Click here for more details"
                />
                <AlertItem
                    par="subscribers_5"
                    alertTime="05/25/2023 @ 02:00PM"
                    msg="You have a new subscriber, Click here for more details"
                />
                <AlertItem
                    par="subscribers_5"
                    alertTime="05/25/2023 @ 02:00PM"
                    msg="You have a new subscriber, Click here for more details"
                />
                <AlertItem
                    par="subscribers_5"
                    alertTime="05/25/2023 @ 02:00PM"
                    msg="You have a new subscriber, Click here for more details"
                />
                <AlertItem
                    par="subscribers_5"
                    alertTime="05/25/2023 @ 02:00PM"
                    msg="You have a new subscriber, Click here for more details"
                />
                <AlertItem
                    par="subscribers_5"
                    alertTime="05/25/2023 @ 02:00PM"
                    msg="You have a new subscriber, Click here for more details"
                />
                <AlertItem
                    par="subscribers_5"
                    alertTime="05/25/2023 @ 02:00PM"
                    msg="You have a new subscriber, Click here for more details"
                />
                <AlertItem
                    par="subscribers_5"
                    alertTime="05/25/2023 @ 02:00PM"
                    msg="You have a new subscriber, Click here for more details"
                />
                <AlertItem
                    par="subscribers_5"
                    alertTime="05/25/2023 @ 02:00PM"
                    msg="You have a new subscriber, Click here for more details"
                />
                <AlertItem
                    par="subscribers_5"
                    alertTime="05/25/2023 @ 02:00PM"
                    msg="You have a new subscriber, Click here for more details"
                />*/}
            </ScrollArea>
            <FooterSimple />
        </>
    )

}

export default AlertsPage
